const translations = {
    apiError: 'Something went wrong. Please try again.',
    title: 'Add Controller'
};

export default translations;
